import { render, staticRenderFns } from "./branch-card-detail.vue?vue&type=template&id=be05b4da&scoped=true"
import script from "./branch-card-detail.vue?vue&type=script&lang=js"
export * from "./branch-card-detail.vue?vue&type=script&lang=js"
import style0 from "./branch-card-detail.vue?vue&type=style&index=0&id=be05b4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be05b4da",
  null
  
)

export default component.exports